var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0606 4.96638C11.5766 3.99238 12.4186 3.98838 12.9366 4.96638L20.0606 18.4244C20.5766 19.3984 20.1056 20.1954 19.0036 20.1954H4.99361C3.89161 20.1954 3.41861 19.4024 3.93661 18.4244L11.0606 4.96638ZM11.2915 14.7065C11.479 14.894 11.7334 14.9994 11.9986 14.9994C12.2638 14.9994 12.5182 14.894 12.7057 14.7065C12.8933 14.5189 12.9986 14.2646 12.9986 13.9994V8.99937C12.9986 8.73416 12.8933 8.4798 12.7057 8.29227C12.5182 8.10473 12.2638 7.99937 11.9986 7.99937C11.7334 7.99937 11.479 8.10473 11.2915 8.29227C11.104 8.4798 10.9986 8.73416 10.9986 8.99937V13.9994C10.9986 14.2646 11.104 14.5189 11.2915 14.7065ZM11.2915 17.7065C11.479 17.894 11.7334 17.9994 11.9986 17.9994C12.2638 17.9994 12.5182 17.894 12.7057 17.7065C12.8933 17.5189 12.9986 17.2646 12.9986 16.9994C12.9986 16.7342 12.8933 16.4798 12.7057 16.2923C12.5182 16.1047 12.2638 15.9994 11.9986 15.9994C11.7334 15.9994 11.479 16.1047 11.2915 16.2923C11.104 16.4798 10.9986 16.7342 10.9986 16.9994C10.9986 17.2646 11.104 17.5189 11.2915 17.7065Z",
    fill: "#E8A700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.9164ab6db05da6bc3b11a6d95a404220.svg";
export { ForwardRef as ReactComponent };